(() => {
  const init = () => {
    const hero = document.querySelector('[data-cd-xmas]');
    if (!hero || hero.dataset.snowReady) return;
    hero.dataset.snowReady = 'true';
    const layer = hero.querySelector('.cd-xmas__snow');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let visible = false, timer = 0, flakes = new Set();
    const stop = () => { clearTimeout(timer); timer = 0; };
    const fall = () => {
      if (!visible || document.hidden || reduced.matches) { stop(); return; }
      if (flakes.size < (innerWidth < 750 ? 13 : 22)) {
        const flake = document.createElement('i');
        flake.className = 'cd-xmas__flake';
        const size = 1.8 + Math.random() * 2.8;
        flake.style.cssText = 'left:' + Math.random() * 100 + '%;width:' + size + 'px;height:' + size + 'px';
        layer.append(flake);
        const animation = flake.animate([
          { transform: 'translate3d(0,-10px,0)', opacity: 0 },
          { opacity: .55, offset: .12 },
          { opacity: .45, offset: .84 },
          { transform: 'translate3d(' + (Math.random() * 70 - 35) + 'px,' + (hero.clientHeight + 20) + 'px,0)', opacity: 0 }
        ], { duration: 10000 + Math.random() * 6500, easing: 'linear', iterations: 1 });
        flakes.add(animation);
        const remove = () => { flakes.delete(animation); flake.remove(); };
        animation.onfinish = remove;
        animation.oncancel = remove;
      }
      timer = setTimeout(fall, innerWidth < 750 ? 850 : 600);
    };
    const start = () => { if (!timer && visible && !document.hidden && !reduced.matches) fall(); };
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      hero.classList.toggle('is-visible', visible && !document.hidden);
      if (visible) start(); else stop();
    }, { threshold: .05 });
    observer.observe(hero);
    document.addEventListener('visibilitychange', () => {
      hero.classList.toggle('is-visible', visible && !document.hidden);
      if (document.hidden) stop(); else start();
    });
    reduced.addEventListener('change', () => {
      if (reduced.matches) { stop(); [...flakes].forEach(animation => animation.cancel()); } else start();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
